import Logo from "@/components/logo";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown, LogOut } from "lucide-react";
import { useKycLogout } from "./use-kyc-logout";
import type { ReactNode } from "react";

const KycShell = ({
  firstName,
  children,
}: {
  // Undefined while the user is still loading.
  firstName?: string;
  children: ReactNode;
}) => {
  const logout = useKycLogout();
  return (
    <div className="text-auth-text">
      <div className="relative flex min-h-dvh">
        <div className="bg-auth-panel fixed inset-y-0 left-0 hidden aspect-617/832 h-screen lg:block">
          <img
            src="/images/auth-image2.svg"
            className="h-full w-auto"
            alt="The New Standard of Digital Finance. Easily create virtual cards to handle every online purchase, bill, and subscription."
          />
        </div>
        <div className="hidden aspect-617/832 h-screen lg:block" />
        <div className="bg-auth-surface relative flex grow flex-col px-5 py-6 lg:px-12 lg:py-8">
          <div className="flex items-center justify-between lg:justify-end">
            <Logo surface="light" className="text-auth-action w-32 lg:hidden" />
            {firstName ? (
              <DropdownMenu>
                <DropdownMenuTrigger className="flex cursor-pointer items-center gap-2 rounded text-sm font-medium outline-none">
                  <span className="flex size-8 items-center justify-center rounded-full bg-[#f3eee4]">
                    {firstName.charAt(0).toUpperCase()}
                  </span>
                  {firstName}
                  <ChevronDown className="text-auth-muted size-4" />
                </DropdownMenuTrigger>
                <DropdownMenuContent
                  align="end"
                  className="border-auth-stroke text-auth-text min-w-36 bg-white"
                >
                  <DropdownMenuItem
                    className="cursor-pointer gap-2"
                    onSelect={logout}
                  >
                    <LogOut className="size-4" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <div className="flex animate-pulse items-center gap-2">
                <span className="size-8 rounded-full bg-[#f3eee4]" />
                <span className="h-4 w-16 rounded bg-[#f3eee4]" />
              </div>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default KycShell;
